module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c(_vm.header, {
    tag: "nav"
  }), _vm._v(" "), _c('router-view', {
    on: {
      "showErrorModal": function($event) {
        _vm.onError($event)
      },
      "showMessageModal": function($event) {
        _vm.onMessage($event)
      },
      "showLoginModal": function($event) {
        _vm.onLogin($event)
      }
    }
  }), _vm._v(" "), _c('footer-bar'), _vm._v(" "), _c('error-modal', {
    ref: "errorModal",
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.isErrorMessageArray) ? _c('ul', _vm._l((_vm.errorModalBody), function(msg) {
    return _c('li', [_vm._v(_vm._s(msg))])
  })) : _c('div', [_vm._v(_vm._s(_vm.errorModalBody))])]), _vm._v(" "), _c('login-modal', {
    ref: "loginModal",
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.loginModalCaption) ? _c('div', [_vm._v(_vm._s(_vm.loginModalCaption))]) : _vm._e()]), _vm._v(" "), _c('message-modal', {
    ref: "messageModal",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.message))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-87f28a6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/App.vue
// module id = 349
// module chunks = 1